<!-- Data Visualization Chart Component Template -->
<div class="data-visualization-container">
  <!-- Data selection chips -->
  <div *ngIf="!loadingSignal() && hasDataSignal()" class="graph-header">
    <div class="chips-container">
      <div *ngFor="let chip of availableChipsSignal()" class="chip" [ngStyle]="getChipStyle">
        <span [style.backgroundColor]="chip.color"></span>
        {{ chip.label }} <b>{{ chip.unit }}</b>
      </div>
    </div>

    <div class="date-container">
      <ng-container *ngIf="resultsFromDialogSignal()">
        <button class="cancel-btn" [disabled]="submitLoadingSignal()" mat-stroked-button color="primary" (click)="onCancel()">
          {{ 'COM.BUTTONS.CANCEL' | translate }}
        </button>
        <button class="submit-btn round-button" [disabled]="submitLoadingSignal()" (click)="saveChangesToAPI()" mat-flat-button color="primary">
          {{ 'COM.BUTTONS.SUBMIT' | translate }}
        </button>
        <mat-spinner *ngIf="submitLoadingSignal()"></mat-spinner>
      </ng-container>

      <!-- <button (click)="previousDay()" mat-icon-button class="time-container_increament" [disabled]="isPreviousDayDisabled()">
        <dr-customer-offers-ui-icons name="chevron_left" size="extra-small"></dr-customer-offers-ui-icons>
      </button> -->
      <span class="date-container--day">{{ formattedCurrentDate }}</span>
      <!-- <button (click)="nextDay()" mat-icon-button class="time-container_increament" [disabled]="isNextDayDisabled()">
        <dr-customer-offers-ui-icons name="chevron_right" size="extra-small"></dr-customer-offers-ui-icons>
      </button> -->
      <div class="relative-position">
        <button
          *ngIf="selectedTabSignal().exportFunctionality && !resultsFromDialogSignal()"
          data-cy="open-tab-more-options"
          mat-icon-button
          (click)="toggleDownloadUploadOptions($event)"
          class="more-options-btn"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <div *ngIf="showDownloadUploadOptionsSignal()" class="download-upload-options" (clickOutside)="clickOutsideDownloadUploadOptions()">
          <button mat-menu-item (click)="openExportFunctionalityDialog()" class="download-upload-options--option">
            <mat-icon class="download-upload-options--option-icon">download</mat-icon>
            <span>{{ 'COM.BUTTONS.EXPORT_REPORT' | translate }}</span>
          </button>
          <button *ngIf="isBulkImportAllowed()" mat-menu-item (click)="openBulkUploadFunctionalityDialog()" class="download-upload-options--option">
            <mat-icon class="download-upload-options--option-icon">upload</mat-icon>
            <span>{{ 'COM.BUTTONS.BULK_UPLOAD' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Chart container -->
  <div class="chart-wrapper">
    <!-- Loading indicator -->
    <div *ngIf="loadingSignal()" class="loading-container">
      <div class="loading-spinner"></div>
      <p>{{ 'COM.TABS.OPEN.CHART.LOADING_TEXT' | translate }}</p>
    </div>

    <ng-container *ngIf="!loadingSignal() && hasDataSignal()">
      <div class="dst-banner" role="status" aria-live="polite" *ngIf="dstStatusSignal().hasDSTTransition">
        <span class="dst-banner__icon" aria-hidden="true">ⓘ</span>

        <span class="dst-banner__text">
          <ng-container *ngIf="dstStatusSignal().type === 'fall_back'"
            >This date includes a Daylight Saving Time shift, resulting in an extra 02:00 hour in the selected time zone.</ng-container
          >
          <ng-container *ngIf="dstStatusSignal().type === 'spring_forward'"
            >This date includes a Daylight Saving Time change, which causes the 02:00 hour to be skipped in the selected time zone.</ng-container
          >
        </span>
      </div>

      <!-- Highcharts Angular Chart - Uses computed chartOptions -->
      <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions()" [callbackFunction]="chartCallback" class="chart-container">
      </highcharts-chart>

      <div class="chart-legend-footer" *ngIf="plotBandsSignal().length || optOutPlotBandsSignal().length">
        <span class="chart-legend-footer__item" *ngIf="plotBandsSignal().length">
          <span class="chart-legend-footer__swatch" [style.backgroundColor]="gateClosedColor"></span>
          {{ 'COM.LEGEND.GATE_CLOSED' | translate }}
        </span>
        <span class="chart-legend-footer__item" *ngIf="optOutPlotBandsSignal().length">
          <span class="chart-legend-footer__swatch" [style.backgroundColor]="optOutColor"></span>
          {{ 'COM.CHECKBOX.OPT_OUT' | translate }}
        </span>
      </div>
    </ng-container>

    <!-- No data message -->
    <div *ngIf="!hasDataSignal() && !loadingSignal()" class="no-data-container">
      <p>{{ 'COM.TABS.OPEN.CHART.NO_CHART_TEXT' | translate }}</p>
    </div>
  </div>

  <!-- Table container -->
  <div class="graph-table" *ngIf="!isConsolidatedToHourly() && !loadingSignal() && hasDataSignal() && tableSeriesSignal().length">
    <dsy-divider divider-orientation="horizontal" divider-color="light-grey"></dsy-divider>
    <div class="graph-table--header">
      <h2>{{ 'COM.TABS.OPEN.CHART.TABLE_HEADER' | translate }}</h2>
      <p>{{ 'COM.TABS.OPEN.CHART.TABLE_DESCRIPTION' | translate }}</p>
    </div>

    <div>
      <dr-customer-offers-ui-open-graph-table
        [offers]="tableSeriesSignal()"
        [timezone]="timeZoneSignal()"
        [currency]="currencySignal()"
        [offerDimensions]="offerDimensionsSignal()"
        [showBaseline]="showBaselineSignal()"
      ></dr-customer-offers-ui-open-graph-table>
    </div>
  </div>
</div>
